export default __webpack_public_path__ + "static/media/esgailogo_white.19d60a07.png";